import * as React from 'react';
//import { AppProps } from '../../components/app';
import PackageListingContainer from '../../components/package-listing-container';
import CartContainer from '../../components/cart/container';
import QuantitySelect from '../../components/cart/quantity-select';
import * as Sticky from 'sticky-js';

import FiltersContainer from '../../components/filters/container';
import { AppProps } from '../../components/app';

interface FixedState {
    stickyInstance: any;
}

class AppView extends React.Component<AppProps, FixedState> {
    constructor(props) {
        super(props);

        this.state = {
            stickyInstance: null
        }
    }

    componentDidMount() {
        this.stickyCart();
    }

    stickyCart() {
        if (this.state) {
            if (this.state.stickyInstance == null) {
                this.setState({
                    stickyInstance: new Sticky('[data-sticky-el]')
                })
            }
            else {
                this.state.stickyInstance.update();
            }
        }
    }
    render() {
        return (
            <>

                {
                    this.props.settings.isRenewal || this.props.settings.voucherPackage ? null
                        :
                        <nav className="ace-filters-container space-top-lg stack-sm">
                            <div className="ace-block-inner">
                                <h2 className="ace-subs-filter-heading">{this.props.text.filtersTitle}</h2>
                            </div>
                            <FiltersContainer />
                        </nav>
                }

                <section className="ace-sidebar-page-wrapper ace-page-section">
                    <div className="ace-sidebar-page-main ace-subs-listing">
                        <PackageListingContainer />
                    </div>
                    {
                        !this.props.settings.useUnseatedReservation ? null :
                            <div className="ace-sidebar-page-sidebar ace-subs-sidebar" id="miniCart">
                                <CartContainer updateStickyCart={this.stickyCart.bind(this)} />
                            </div>
                    }
                </section>
            </>
        );
    }
}

export default AppView;